import { call, put, take } from "redux-saga/effects";
import { subscribe } from "./subscribe";

export function* read(socket) {
  const channel = yield call(subscribe, socket);
  while (true) {
    const action = yield take(channel);

    yield put(action);
  }
}
